import React from 'react';

const Awair2ndLogo = ({ width = 236, height = 42 }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 471 42"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="Page-1" fill="none" fillRule="evenodd">
        <g id="intro_5" transform="translate(-138 -357)">
          <g id="IMG">
            <g id="rev2_tutorial_intro">
              <g id="rev2_tutorial_0">
                <g id="Group-2" transform="translate(105 289)">
                  <g transform="translate(0 64)" id="logo_awair_2nd">
                    <rect id="Rectangle" width="540" height="60" />
                    <g id="Group-2" transform="translate(0 5)" fill="#FFF">
                      <g>
                        <path
                          fill-rule="nonzero"
                          d="M13.863.07L0 39.813h8.154L10.55 32.8h14.028l2.35 7.012h8.13L21.148.07h-7.285zm8.624 26.118h-9.751l4.957-14.306 4.794 14.306zM104.774.07h-7.26L83.65 39.813h8.13l2.397-7.012h14.028l2.35 7.012h8.13L104.868.329l-.094-.258zm1.363 26.118h-9.751l4.958-14.306 4.793 14.306z"
                          transform="translate(-105 -353) translate(105 353) translate(73 4) translate(0 1)"
                        />
                        <path
                          d="M75.732.071L69.575 24.988 62.362.071 56.534.071 49.321 24.988 43.235.071 35.105.071 45.679 39.812 52.187 39.812 59.448 15.812 66.709 39.812 73.217 39.812 83.862.071zM125.123.071H132.924V39.812H125.123z"
                          transform="translate(-105 -353) translate(105 353) translate(73 4) translate(0 1)"
                        />
                        <path
                          fill-rule="nonzero"
                          d="M165.374 21.765l.681-.47c.87-.613 1.645-1.366 2.326-2.236.658-.87 1.199-1.883 1.598-2.988.4-1.106.588-2.4.588-3.812 0-1.67-.282-3.247-.87-4.73-.587-1.458-1.433-2.776-2.537-3.858-1.105-1.083-2.491-1.977-4.065-2.636-1.598-.659-3.408-.988-5.405-.988h-15.555v39.741h7.801V23.953h6.086c.634 0 1.786 0 2.632-.024l5.169 15.86h8.154l-6.603-18.024zm-2.632-9.553c0 1.53-.517 2.8-1.527 3.74-1.01.942-2.373 1.436-4.065 1.436h-7.237V7.035h7.26c1.692 0 3.055.494 4.065 1.436.987.964 1.504 2.211 1.504 3.74z"
                          transform="translate(-105 -353) translate(105 353) translate(73 4) translate(0 1)"
                        />
                      </g>
                      <path
                        fill-rule="nonzero"
                        d="M219.952 41v-2.52h-21.504V21.96h18.984v-2.576h-18.984V4.376h21.504V1.8h-24.528V41h24.528zm9.331 0V.12h-2.8V41h2.8zm19.915.56c7.448 0 11.424-5.208 12.768-9.408h-3.136c-.952 2.632-3.304 6.888-9.744 6.888-6.552 0-10.696-4.872-10.864-11.368h24.136C263.31 19.776 257.542 13 249.086 13c-8.344 0-13.832 5.88-13.832 14.28 0 8.344 5.096 14.28 13.944 14.28zm10.472-16.408h-21.448c.168-5.824 5.376-9.632 10.864-9.632 6.888 0 10.584 5.432 10.584 9.632zM271.185 41V27.392c0-6.048 3.36-11.872 9.016-11.872 5.544 0 8.176 4.256 8.176 9.24V41h2.8V26.664c0-5.376 3.024-11.144 9.128-11.144 5.768 0 7.28 4.312 7.28 9.24V41h2.8V24.76c0-6.944-2.8-11.76-9.688-11.76-7.056 0-9.688 4.48-10.416 6.832-1.344-4.2-4.424-6.832-9.856-6.832-3.92 0-7.728 2.296-9.24 5.376V13.56h-2.8V41h2.8zm58.779.56c7.448 0 11.424-5.208 12.768-9.408h-3.136c-.952 2.632-3.304 6.888-9.744 6.888-6.552 0-10.696-4.872-10.864-11.368h24.136C344.076 19.776 338.308 13 329.852 13c-8.344 0-13.832 5.88-13.832 14.28 0 8.344 5.096 14.28 13.944 14.28zm10.472-16.408h-21.448c.168-5.824 5.376-9.632 10.864-9.632 6.888 0 10.584 5.432 10.584 9.632zM351.951 41V26.496c0-6.832 5.152-10.976 9.688-10.976 4.984 0 8.96 2.912 8.96 10.024V41h2.8V25.04c0-7.224-4.424-12.04-11.2-12.04-6.16 0-9.296 3.976-10.248 5.768V13.56h-2.8V41h2.8zm38.003.56v-3.024c-3.192-.224-3.976-2.688-3.976-6.888V16.136h7.112V13.56h-7.112V6h-2.8v7.56h-4.368v2.576h4.368v16.856c0 5.32 2.352 8.568 6.776 8.568z"
                        transform="translate(-105 -353) translate(105 353) translate(73 4)"
                      />
                    </g>
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};

export default Awair2ndLogo;



// WEBPACK FOOTER //
// ./src/app/intro/components/Logo/ElementLogo.js